import React from 'react';
import { NavLink } from 'react-router-dom';
import CapriGlobalLogo from '../../../assets/capri-global-logo.svg';
import { company, routes, ui } from '../../models/content';
import { useMobileMenu } from '../../controllers/useMobileMenu';
import { useBodyClass } from '../../controllers/useBodyClass';

function navLinkClass({ isActive }) {
  return isActive ? 'is-active' : undefined;
}

export default function V2Header() {
  const menu = useMobileMenu();
  useBodyClass('menu-open', menu.open);

  return (
    <header className="site-header">
      <div className="utility-bar">
        <div className="wrap">
          <div className="left">
            <span className="util-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
              <a href={company.phoneHref}>{company.phoneDisplay}</a>
            </span>
            <span className="util-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
              <a href={ui.utilityEmailHref}>{ui.utilityEmailDisplay}</a>
            </span>
          </div>
          <div className="right">
            <span>{company.location}</span>
            <NavLink to={routes.contact} onClick={menu.close}>
              Investor Enquiries →
            </NavLink>
          </div>
        </div>
      </div>

      <div className="pill">
        <NavLink
          className="brand"
          to={routes.home}
          aria-label={`${ui.brandName} — Home`}
          onClick={menu.close}
        >
          <img className="brand-logo" src={CapriGlobalLogo} alt={ui.brandName} />
        </NavLink>

        {/* Menu control before nav in source so SR reading order matches expand/collapse (CIWX-106). */}
        <button
          className="menu-toggle"
          type="button"
          aria-label={menu.open ? 'Close menu' : 'Menu'}
          aria-expanded={menu.open}
          aria-controls="primary-nav"
          onClick={menu.toggle}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            {menu.open ? (
              <path d="M18 6L6 18M6 6l12 12" />
            ) : (
              <path d="M4 7h16M4 12h16M4 17h16" />
            )}
          </svg>
        </button>

        <nav id="primary-nav" className="nav" aria-label="Primary" onClick={menu.close}>
          <NavLink to={routes.home} className={navLinkClass}>
            Home
          </NavLink>
          <NavLink to={routes.about} className={navLinkClass}>
            About Us
          </NavLink>
          <NavLink to={routes.fund} className={navLinkClass}>
            Capri Stressed Assets Fund
          </NavLink>
          <NavLink to={routes.teams} className={navLinkClass}>
            Teams
          </NavLink>
          <NavLink to={routes.portfolio} className={navLinkClass}>
            Our Portfolio
          </NavLink>
          <NavLink to={routes.news} className={navLinkClass}>
            News and Media
          </NavLink>
          <NavLink to={routes.regulatory} className={navLinkClass}>
            Regulatory
          </NavLink>
          <NavLink className="nav-cta btn btn-primary" to={routes.contact} onClick={menu.close}>
            Get in Touch →
          </NavLink>
        </nav>

        <NavLink className="btn btn-primary header-cta" to={routes.contact} onClick={menu.close}>
          Get in Touch →
        </NavLink>
      </div>
    </header>
  );
}
